import { Box, Typography } from "@mui/material";
import React, { useContext } from "react";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";

export const LanguageButton = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  const selectedSx = {
    px: 1.8,
    py: 0.8,
    cursor: "pointer",
    backgroundColor: "var(--clr-primary)",
    transition: "all 0.3s ease",
  };

  const unselectedSx = {
    px: 1.8,
    py: 0.8,
    cursor: "pointer",
    backgroundColor: "var(--common-white)",
    border: "1px solid var(--clr-primary)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(192, 166, 97, 0.1)",
    },
  };

  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: 1000,
        bottom: 32,
        left: 20,
        display: "flex",
        alignItems: "center",
        boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
      }}
    >
      <Box
        onClick={() => setLanguage("en")}
        sx={language === "en" ? selectedSx : unselectedSx}
      >
        <Typography
          sx={{
            fontFamily: "'Lato', sans-serif",
            fontSize: "0.75rem",
            fontWeight: 600,
            letterSpacing: "0.1em",
            color: language === "en" ? "#fff" : "var(--clr-primary)",
            transition: "color 0.3s ease",
          }}
        >
          EN
        </Typography>
      </Box>
      <Box
        onClick={() => setLanguage("pt")}
        sx={language === "pt" ? selectedSx : unselectedSx}
      >
        <Typography
          sx={{
            fontFamily: "'Lato', sans-serif",
            fontSize: "0.75rem",
            fontWeight: 600,
            letterSpacing: "0.1em",
            color: language === "pt" ? "#fff" : "var(--clr-primary)",
            transition: "color 0.3s ease",
          }}
        >
          PT
        </Typography>
      </Box>
    </Box>
  );
};
